import { useEffect, useRef } from "react";

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

const HeaderAd = () => {
  const adRef = useRef<HTMLDivElement>(null);
  const adInitialized = useRef(false); // ✅ prevents duplicate push

  useEffect(() => {
    if (adInitialized.current) return; // 🚫 stop second run

    try {
      if (window.adsbygoogle && adRef.current) {
        window.adsbygoogle.push({});
        adInitialized.current = true; // ✅ mark as initialized
      }
    } catch (e) {
      // AdSense initialization error - fail silently in production
    }
  }, []);

  return (
    <div ref={adRef} style={{ margin: "10px 0", minHeight: "90px" }}>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-1599853380737685"
        data-ad-slot="1704303608"
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default HeaderAd;
